export const Arrow45DegIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#F2EDFE" />
      <path
        d="M17.0002 7V14.7781M6.99976 17.0004L17.0002 7L6.99976 17.0004ZM17.0002 7L9.22205 7.00001L17.0002 7Z"
        stroke="#7647EE"
        strokeWidth="1.57141"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
